export default (str) => str.startsWith('mailto');
